<template>
  <GModal ref="modalSeeMoreReviews" class="modal--see-more-reviews">
    <div slot="header">
      <button type="button" class="close" aria-label="Close">
        <img
          src="/assets/img/sprite-icon-svg/back-header-icon.svg"
          alt="icon-close-modal"
          @click.prevent="closeModal"
        />
      </button>
      <h2 class="modal-heading">User Reviews ({{ totalReviews | cnvrtNumberToK }})</h2>
    </div>
    <div slot="body" class="review-wrapper" @scroll="onScroll">
      <div class="review-read">
        <img
          src="/assets/img/expert-review/read-see-more-review-mobile.svg"
          width="51.5"
          height="29.38970375061035"
          alt="read-review"
        />
        <p>
          <span class="bold">Baca <span class="bold italic">reviews</span></span> dari
          <span class="bold italic">real users</span> untuk bantu kamu memilih & membeli produk yang
          <span class="bold">tepat dengan kebutuhanmu!</span>
        </p>
      </div>
      <div class="review-header">
        <div class="review-stats">
          <template v-if="averageRating">
            <ul class="list-give-rating">
              <li v-for="(value, key) in ratingTypes" :key="key" class="list-give-rating__item">
                <span class="list-give-rating__value"
                  ><span class="bolder">{{ value.toFixed() }}</span
                  >/5</span
                >
                <span class="list-give-rating__text">{{ key | generatedRatingTypeName }}</span>
              </li>
            </ul>
            <div class="average-rating">
              <img src="/assets/img/star_pink.svg" alt="star" height="14" width="15.5" />
              <span>{{ averageRating }}</span>
            </div>
          </template>
        </div>
        <div class="review-recommend-repurchase">
          <div class="review-recommend">
            <img src="/assets/img/thumb-pink.svg" alt="thumb" height="13.3" width="14" />
            <p>
              <span class="percentage">{{ Math.ceil((totalRecommend / totalReviews) * 100) }}%</span>
              <span> Users Recommend</span>
            </p>
          </div>
          <div class="review-repurchase">
            <img src="/assets/img/repurchase-pink.svg" alt="wallet" height="14" width="14" />
            <p>
              <span class="percentage">{{ Math.ceil((totalRepurchase / totalReviews) * 100) }}%</span>
              <span> Users Repurchase</span>
            </p>
          </div>
        </div>
      </div>
      <div :class="['review-content', { sticky: is_sticky }]">
        <filteredReviews
          :product="product"
          :is_section="false"
          :auto-fetch="true"
          :use-button-to-load-more="false"
          :load-more-loading-text="false"
          :scroll-position="scrollY"
        />
      </div>
    </div>
  </GModal>
</template>

<script>
import { get } from 'lodash';
export default {
  name: 'ModalSeeMoreReviews',
  components: {
    GModal: () => import('@/components/global/GModal'),
    filteredReviews: () => import('@/components/product/product-detail/filteredReviews'),
  },
  props: {
    product: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      is_sticky: false,
      scrollY: 0,
    };
  },
  computed: {
    averageRating() {
      let result = 0;
      try {
        if (this.$SO.size(this.product.review_stats) && this.product.review_stats.average_rating) {
          result = this.$options.filters.productrating(this.product.review_stats.average_rating);
        }
      } catch (error) {}
      return result;
    },
    ratingTypes() {
      return get(this.product, 'review_stats.average_rating_by_types', {});
    },
    totalReviews() {
      return get(this.product, 'review_stats.total_reviews', 0);
    },
    totalRecommend() {
      return get(this.product, 'review_stats.total_recommended_count', 0);
    },
    totalRepurchase() {
      return get(this.product, 'review_stats.total_repurchase_yes_count', 0);
    },
    filteredReviewsComponent() {
      return this.$refs['filtered-reviews'];
    },
  },
  created() {
    this.$SO('body').addClass('no-scroll');
  },
  beforeDestroy() {
    this.$SO('body').removeClass('no-scroll');
  },
  methods: {
    closeModal() {
      this.$store.commit('setModalSeeMoreReviews', false);
    },
    onScroll(e) {
      const filterBar = document.getElementsByClassName('filter-bar');
      if (filterBar && filterBar[0]) {
        const rect = filterBar[0].getBoundingClientRect();
        this.is_sticky = Boolean(rect && rect.top < 62);
      }
      this.scrollY = e.target.scrollTop;
    },
  },
};
</script>
